import { PROTECTION_SERVICES_EXPERIAN_FORM }  from "../constants";

const initialState = {}

const VerifyProtectionServicesExperianReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case PROTECTION_SERVICES_EXPERIAN_FORM.VERIFY_PROTECTION_SERVICES_EXPERIAN_DETAILS:
            return {
                ...payload
            }
        case PROTECTION_SERVICES_EXPERIAN_FORM.VERIFY_PROTECTION_SERVICES_EXPERIAN_DETAILS_CHECK_MY_REQUESTS:
            return {
                ...payload
            }
        case PROTECTION_SERVICES_EXPERIAN_FORM.VERIFY_PROTECTION_SERVICES_EXPERIAN_SUCCESS:
            return {
                ...payload
            }
        case PROTECTION_SERVICES_EXPERIAN_FORM.VERIFY_PROTECTION_SERVICES_EXPERIAN_FAIL:
            return {
                ...payload
            }
               
        default:
            return state;
    }
}

export default VerifyProtectionServicesExperianReducer;
